/* eslint-disable import/prefer-default-export */
import { setCookie } from 'nookies'

import { SITES_SELECTED } from '@constants'

export default function action(id) {
  setCookie(null, 'siteId', id, { sameSite: 'strict' })
  return { type: SITES_SELECTED, payload: { id } }
}
